import {useDocumentStore} from '@/components/document/store';

export const useIsAnyGroupModalOpen = (): boolean =>
  useDocumentStore(state =>
    Object.entries(state.data).some(([fieldId, value]) => fieldId.endsWith('[open]') && value === 'true'),
  );
